var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-panel",on:{"click":_vm.onClick}},[_c('div',{staticClass:"card-panel-icon-wrapper",style:(_vm.iconWrapperStyles)},[_vm._t("icon")],2),_c('div',{staticClass:"card-panel-description"},[_c('div',{staticClass:"card-panel-text"},[_vm._v(_vm._s(_vm.title))]),_vm._t("number")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }